import { render, staticRenderFns } from "./loader2.vue?vue&type=template&id=64cd4678&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64cd4678')) {
      api.createRecord('64cd4678', component.options)
    } else {
      api.reload('64cd4678', component.options)
    }
    module.hot.accept("./loader2.vue?vue&type=template&id=64cd4678&", function () {
      api.rerender('64cd4678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/general/loader2.vue"
export default component.exports